import React from 'react'
import { useIntl } from '@jetshop/intl'
import FilterDropdown from './FilterDropdown'
import FilterPanelFooter from './FilterPanelFooter'
import PriceFilterContent, {
   getSelectedPriceRange,
   usePriceBounds,
} from './PriceFilterContent'
import { DIGIFI_FILTER_FIELD_NAMES } from '../../DigifiSearch/constants'

/**
 * Desktop price filter dropdown.
 */
const PriceFilterDropdown = ({
   filters,
   facets,
   totalCount,
   updateFilters,
}) => {
   const t = useIntl()
   const bounds = usePriceBounds(facets)
   const hasSelection = !!getSelectedPriceRange(filters)

   if (!bounds.max) {
      return null
   }

   return (
      <FilterDropdown
         label={t('Price')}
         isActive={hasSelection}
         panelWidth="380px"
      >
         {({ close }) => (
            <>
               <div style={{ padding: '1.25rem 1.25rem 0' }}>
                  <PriceFilterContent
                     filters={filters}
                     facets={facets}
                     updateFilters={updateFilters}
                  />
               </div>
               <FilterPanelFooter
                  onClear={() =>
                     updateFilters?.([
                        {
                           fieldName: DIGIFI_FILTER_FIELD_NAMES.PRICE,
                           value: null,
                        },
                     ])
                  }
                  clearDisabled={!hasSelection}
                  onSubmit={close}
                  totalCount={totalCount}
               />
            </>
         )}
      </FilterDropdown>
   )
}

export default PriceFilterDropdown
